import { useState } from "react";
import { toast } from "sonner";
import { renderResultCard, canvasToBlob } from "@/lib/shareCard";
import { useSite } from "@/context/SiteContent";

export const ShareResult = ({ result }) => {
  const pData = useSite().fivePs.items;
  const [busy, setBusy] = useState("");
  const fileName = `my-5ps-focus-${result.primary}.png`;
  const shareText = `My 5Ps focus right now is ${pData[result.primary].name}, with ${pData[result.secondary].name} as a secondary focus. Take the free 2-minute Campus2Corp 5Ps quiz by Scott Tang.`;
  const siteUrl = `${window.location.origin}/#quiz`;

  const makeBlob = async () => canvasToBlob(await renderResultCard(result));

  const download = async () => {
    setBusy("download");
    try {
      const blob = await makeBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = fileName; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success("Your 5Ps result image is ready.");
    } catch (e) { toast.error("Could not create the image. Please try again."); }
    finally { setBusy(""); }
  };

  const share = async () => {
    setBusy("share");
    try {
      const blob = await makeBlob();
      const file = new File([blob], fileName, { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: "My 5Ps focus", text: shareText, url: siteUrl });
      } else if (navigator.share) {
        await navigator.share({ title: "My 5Ps focus", text: shareText, url: siteUrl });
      } else {
        await navigator.clipboard.writeText(`${shareText} ${siteUrl}`);
        toast.success("Share text and link copied. Download the image to attach it.");
      }
    } catch (e) { if (e?.name !== "AbortError") toast.error("Sharing is not available here. Try downloading the image instead."); }
    finally { setBusy(""); }
  };

  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(siteUrl)}`;

  return (
    <div className="share-result" data-testid="quiz-share-panel">
      <div className="share-result-copy">
        <span className="insight-kicker">Share your focus</span>
        <p>Save a branded card of your 5Ps radar, or send a friend who is making the same transition.</p>
      </div>
      <div className="share-result-actions">
        <button className="share-btn" onClick={download} disabled={!!busy} data-testid="quiz-download-image-btn">{busy === "download" ? "Creating..." : "Download image"}</button>
        <button className="share-btn" onClick={share} disabled={!!busy} data-testid="quiz-share-btn">{busy === "share" ? "Preparing..." : "Share"}</button>
        <a className="share-btn" href={linkedin} target="_blank" rel="noopener noreferrer" data-testid="quiz-linkedin-share-link">Post on LinkedIn ↗</a>
      </div>
    </div>
  );
};
